module.exports = __webpack_public_path__ + "static/media/league-champion.6433813f.png";